import { isSessionExclusivePackEnabled } from "~/domains/user/sessionRuntime";

export const isPackageRestrictionEnabled = () => isSessionExclusivePackEnabled();
